





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { needSmoothCheck, vote } from '@/api/api';
import SlideVerify from '@/components/SlideVerify.vue';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
@Component({
  components: {
    SlideVerify,
  },
})
export default class VoteButton extends Vue {
  @Prop({ default: false }) mustApp!: boolean;
  @Prop() voteName!: string;
  @Prop() voteId!: string | number;
  @Prop({ default: true }) voteWeChat!: boolean;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  SlideShow = false;
  pointOut = false;
  unionId!: string | null;
  mounted() {
    const userLogin = window.gettoken() && window.gettoken() !== 'null';
    if (window.udid && !userLogin) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
      return false;
    }
  }
  startVote() {
    // 开始投票，判断是不是必须在app内投票
    if (this.voteWeChat && isWeiXin()) {
      this.unionId = window.localStorage.getItem('unionid');
      const data = {
        id: this.voteId,
        unionid: this.unionId,
      };
      vote(this.voteName, data).then((result: any) => this.successVote(result));
    } else if (window.udid) {
      const data = {
        id: this.voteId,
        udid: window.udid,
        appkey: window.appkey,
      };
      const userLogin = window.gettoken() && window.gettoken() !== 'null';
      if (window.udid && !userLogin) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
        return false;
      } else {
        vote(this.voteName, data).then((result: any) =>
          this.successVote(result),
        );
      }
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
  fSlideData(res: object) {
    this.SlideShow = false;
    if (this.voteWeChat && isWeiXin()) {
      const data = {
        id: this.voteId,
        unionid: this.unionId,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    } else if (window.udid) {
      const data = {
        id: this.voteId,
        udid: window.udid,
        appkey: window.appkey,
      };
      const lastData = Object.assign(res, data);
      const userLogin = window.gettoken() && window.gettoken() !== 'null';
      if (window.udid && !userLogin) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
        return false;
      } else {
        vote(this.voteName, lastData).then((result: any) =>
          this.successVote(result),
        );
      }
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
  successVote(res: any) {
    switch (res.code) {
      case 200:
        this.$emit('votSuccess', res.data);
        break;
      case 201:
        this.SlideShow = true;
        break;
      case 202:
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        break;
      case 500:
        Toast.fail(res.msg);
        break;
      case 505:
        localStorage.removeItem('unionid');
        window.location.reload();
        break;
      case 203:
        if (this.voteWeChat && isWeiXin()) {
          Dialog.confirm({
            title: '友情提示',
            message: '投票次数已满，打开上游新闻app可再获得10次投票机会',
            confirmButtonText: '还没装？一步安装',
            cancelButtonText: '我已安装过',
            closeOnClickOverlay: true,
          })
            .then(() => {
              window.location.href = this.downLoadUrl;
            })
            .catch(() => {
              if (isWeiXin() === true) {
                this.pointOut = true;
              } else {
                window.location.href =
                  'shangyounews://{"dt":"7","url":"' +
                  document.location.href +
                  '"}';
              }
            });
        } else {
          Toast.fail(res.msg);
        }
        break;
      case 204:
        Toast.fail(res.msg);
        break;
      case 300:
        Toast.fail(res.msg);
        break;
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
}
